import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

const addToSection = createSlice({
  name: "section",

  initialState,

  reducers: {
    //here we will write our reducer
    //Adding todos
    addSection: (state, action) => {
      state.push(action.payload);
      return state;
    },
    addCourse: (state, action) => {
      state.push(action.payload);
      return state;
    },
    /* addTodos: (state, action) => {
      state.push(action.payload);
      return state;
    }, */
   /*  getRecipes: (state) => {
      state.loading = true;
    },
    getRecipesSuccess: (state, { payload }) => {
      state.recipes = payload;
      state.loading = false;
      state.hasErrors = false;
    },
    getRecipesFailure: (state) => {
      state.loading = false;
      state.hasErrors = true;
    }, */
  },
});

export const { addSection, addCourse, getRecipes,getRecipesFailure,getRecipesSuccess } = addToSection.actions;
export const reducer = addToSection.reducer;

// Three actions generated from the slice
// export const { addCourse,addSection } = addToSection.actions

// A selector
// export const recipesSelector = state => state.recipes

// The reducer
// export default addToSection.reducer

// Asynchronous thunk action
/* export function fetchRecipes() {
  return async dispatch => {
    dispatch(getRecipes())

    try {
      const response = await fetch(
        "https://courses-backend-production.up.railway.app/api/v1/admin/course/"
      );
      const data = await response.json()

      dispatch(getRecipesSuccess(data))
    } catch (error) {
      dispatch(getRecipesFailure())
    }
  }
} */